import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

export const DOC = gql`
  ${fragments.appPage.DOC}
  mutation UpdatePage(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $updates: AppPageUpdates!
    $updatePageId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          updatePage(id: $updatePageId, updates: $updates) {
            ...FragmentAppPage
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.nonNull(
  graphql.transformers.OUT.select<
    graphql.schema.UpdatePageMutation,
    ents.core.admin.App.Page,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'updatePage',
          fragments.appPage.TRANSFORMER,
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.UpdatePageMutation,
  ents.core.admin.App.Page,
  graphql.schema.UpdatePageMutationVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
